var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5503 3.28428C10.8432 2.99139 11.3181 2.99139 11.611 3.28428L15.7362 7.40951C16.0291 7.7024 16.0291 8.17728 15.7362 8.47017C15.4433 8.76306 14.9684 8.76306 14.6755 8.47017L10.5503 4.34494C10.2574 4.05205 10.2574 3.57718 10.5503 3.28428Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3316 2.62389V2.62389L2.43452 13.521L1.8216 17.1985L5.49908 16.5856L16.3962 5.68845V5.68845C16.5649 5.51967 16.6597 5.29072 16.6597 5.05209C16.6597 4.81342 16.5649 4.58452 16.3962 4.41572L14.6044 2.62389C14.4356 2.45515 14.2067 2.36035 13.968 2.36035C13.7294 2.36035 13.5004 2.45519 13.3316 2.62389ZM12.2711 1.56307C12.7212 1.11312 13.3316 0.860352 13.968 0.860352C14.6044 0.860352 15.2148 1.11312 15.6649 1.56307L17.4569 3.35514C17.9069 3.80523 18.1597 4.41567 18.1597 5.05209C18.1597 5.68851 17.907 6.29887 17.457 6.74895L6.38979 17.8162C6.27926 17.9267 6.13695 18 5.98276 18.0257L1.03249 18.8507C0.793571 18.8905 0.55013 18.8125 0.378859 18.6412C0.207588 18.47 0.129574 18.2265 0.169394 17.9876L0.994439 13.0373C1.02014 12.8831 1.09337 12.7408 1.2039 12.6303L12.2711 1.56307Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.99bd8722255cc062648bd4c955d489c3.svg";
export { ForwardRef as ReactComponent };